import { ToggleGroup } from '@madpaws/design-system';
import { Field, useFormikContext } from 'formik';
import React from 'react';

import { BOOKING_TYPE_MARKETPLACE, BOOKING_TYPE_RWB } from '~/components/utils/search';

import styles from './ExpandedBookingTypeField.module.css';
import { RWB_SERVICE_NAMES, SEARCH_FILTERS_FORM_KEYS as KEYS } from '../../constants';

import type { ToggleGroupOnChange } from '@madpaws/design-system';
import type { FieldProps } from 'formik';
import type { ReactElement } from 'react';
import type { SearchFilters } from '~/common/types/search';

export const ExpandedBookingTypeField = (): ReactElement => {
  const { setFieldValue } = useFormikContext<SearchFilters>();

  const handleChange = (event: ToggleGroupOnChange): void => {
    const {
      target: { value },
    } = event;

    const newFieldVAlue = value.includes(BOOKING_TYPE_RWB)
      ? BOOKING_TYPE_RWB
      : BOOKING_TYPE_MARKETPLACE;

    setFieldValue(KEYS.bookingType, newFieldVAlue);
  };

  const legend = 'How often?';
  const options = [{ value: BOOKING_TYPE_RWB, label: 'Weekly Service' }];

  return (
    <Field name={KEYS.bookingType}>
      {({ field: { value }, form }: FieldProps): ReactElement | null => {
        if (!RWB_SERVICE_NAMES.includes(form.values.service.type)) {
          return null;
        }

        const checkboxValue = typeof value === 'string' ? [value] : value;

        return (
          <div className={styles.bookingTypeField}>
            <ToggleGroup
              isLegendVisuallyHidden
              legend={legend}
              name={KEYS.bookingType}
              onChange={handleChange}
              options={options}
              value={checkboxValue}
            />
          </div>
        );
      }}
    </Field>
  );
};
